<template>
    <div class="bloc">
        <bloc-header>产业联盟</bloc-header>
        <div class="container">
            <!-- 企业风采 -->
            <section class="public">
                <div class="box">
                    <span class="title">企业风采</span>
                    <span class="line"></span>
                    <router-link 
                        tag="span" 
                        class="more"
                        :to="{name: 'Policy',query: {id: '78e53cf93cb14255a93e5af051db65a6 ',title: '企业风采',mode: 'PICTURE'}}"
                    >
                        更多
                    </router-link>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <div class="swiper">
                    <swiper :options="swiperOption" v-if="swiperList.length">
                        <swiper-slide v-for="item in swiperList" :key="item.id">
                            <router-link tag="div" class="slideBox" :to="{name: 'Detail',query:{id: item.id,mode: 'PICTURE'}}">
                                <img :src="item.image" alt="">
                                <p class="dis"><span>{{ item.introduce }}</span></p>
                            </router-link>
                        </swiper-slide>
                        <div class="swiper-pagination"  slot="pagination"></div>
                    </swiper> 
                </div>
            </section>
            <!-- 个人风采 -->
            <section class="public each">
                <div class="box">
                    <span class="title">个人风采</span>
                    <span class="line"></span>
                    <router-link 
                        tag="span" 
                        class="more"
                        :to="{name: 'Policy',query: {id: '78e53cf93cb14255a93e5af051db65a7 ',title: '个人风采',mode: 'PICTURE'}}"
                    >
                        更多
                    </router-link>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <swiper 
                    class="swiperPersonal"
                    :options="swiperPersonalOption" 
                    v-if="swiperPersonalList.length"
                >
                    <swiper-slide 
                        class="swiperPersonalSlide"
                        v-for="item in swiperPersonalList" 
                        :key="item.id"
                    >
                        <div class="icon">
                            <img :src="item.image" alt="">
                        </div>
                        <div class="isShow">
                            <h1 class="title">{{item.name}}&emsp;&emsp;{{item.introduce.slice(12)}}</h1>
                            <p>{{item.introduce.slice(0, 12)}}</p>
                        </div>
                    </swiper-slide>
                </swiper> 
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
            </section>
            <!-- 协会活动 -->
            <section class="public">
                <div class="box">
                    <span class="title">协会活动</span>
                    <span class="line"></span>
                    <router-link 
                        tag="span" 
                        class="more"
                        :to="{name: 'Policy',query: {id: 'd364002cd2de4a1ab14306f5f513da0f ',title: '协会活动',mode: 'PICTURE'}}"
                    >
                        更多
                    </router-link>
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <router-link 
                    tag="dl" 
                    class="activity"
                    :to="{name: 'Detail', query: {id: activitiesInfo.id,mode: 'PICTURE'}}"
                >
                    <dt class="pic">
                        <img :src="activitiesInfo.image" alt="">
                    </dt>
                    <dd class="rt">
                        <p class="text">{{ activitiesInfo.name }}</p>
                        <p class="times">{{ activitiesInfo.createDate.split(' ')[0] }}</p>
                    </dd>
                </router-link>
            </section>
            <!-- 国内企业 -->
            <section class="public">
                <div class="box">
                    <span class="title">区内企业</span>
                    <span class="line"></span>
                    <!-- <router-link 
                        tag="span" 
                        class="more"
                        :to="{name: 'Policy',query: {title: '企业风采',mode: 'PICTURE'}}"
                    >
                        更多
                    </router-link> -->
                    <img class="bd" src="../../assets/images/bd_icon.png" alt="">
                </div>
                <ul class="firmList">
                    <li
                        class="firmLis" 
                        :class="{active: current == index}"
                        v-for="(item,index) in companyTypeList" :key="item.id"
                        @click="hanldeItemClick(item,index)"
                    >
                        {{item.name}}
                    </li>
                </ul>
                <ul class="videoList">
                    <li class="videolis" v-for="(item, index) in companyList" :key="index">
                        <div class="icon">
                            <img :src="item.image" alt="">
                        </div>
                        <p class="words">{{item.name}}</p>
                        <p class="words">{{item.introduce}}</p>
                    </li>
                </ul>
            </section>
        </div>
    </div>
</template>

<script>
import blocHeader from '../../components/Header';
export default {
    name: 'bloc',
    components: {
        blocHeader
    },
    data() {
        return {
            swiperList: [], //企业风采
            swiperOption: {
                observer:true,
                observeParents:true,
                autoplay: {
                    disableOnInteraction: false,
                    delay: 3000
                },
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    bulletClass : 'my-bullet',
                    bulletActiveClass: 'my-bullet-active',
                }
            },
            swiperPersonalList: [], //个人风采
            swiperPersonalOption: {
                observer:true,
                observeParents:true,
                loop: true,
                autoplay: {
                    disableOnInteraction: false,
                    delay: 3000
                },
                slidesPerView : 3,
                centeredSlides : true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            },
            activitiesInfo: {
                createDate: ''
            },
            companyTypeList: [],
            companyList: [],
            current: 0
        }
    },
    mounted() {
        // 企业风采
        this.getCorStyleList()
        // 个人风采
        this.getPerStyleList()
        // 协会活动
        this.getActivities()
         //区内企业类型列表
        this.getCompanyTypeList()  
        // 区内企业列表
        this.getCompanyList('4921c5b4cfaf11e98c6100163e023a68 ')
    },
    methods: {
        // 企业风采
        getCorStyleList(pageNo=1,pageSize=10) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/listByCategoryId',
                method: 'GET',
                params: {
                    categoryId: '78e53cf93cb14255a93e5af051db65a6  ',
                    pageNo,
                    pageSize,
                    contentType: 'PICTURE'
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.swiperList = res.data.page.list
                    console.log(this.swiperList);
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 个人风采
        getPerStyleList(pageNo=1,pageSize=10) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/listByCategoryId',
                method: 'GET',
                params: {
                    categoryId: '78e53cf93cb14255a93e5af051db65a7   ',
                    pageNo,
                    pageSize,
                    contentType: 'PICTURE'
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.swiperPersonalList = res.data.page.list
                    console.log(this.swiperPersonalList);
                    // this.swiperList = res.data.page.list
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 协会活动
        getActivities() {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/listByCategoryId',
                method: 'GET',
                params: {
                    categoryId: 'd364002cd2de4a1ab14306f5f513da0f     ',
                    pageNo: 1,
                    pageSize: 1,
                    contentType: 'PICTURE'
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.activitiesInfo = res.data.page.list[0]
                    console.log(this.activitiesInfo);
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 获取企业类型列表以及实例
        getCompanyTypeList() {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/companytypelistandcase',
                method: 'GET'
            }).then(res => {
                if(res.data.code == 0){
                    this.companyTypeList = res.data.list
                    console.log(this.companyTypeList);
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 根据企业类型获取企业列表
        getCompanyList(companyType,pageNo=1,pageSize=10) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/companylist',
                method: 'GET',
                params: {
                    companyType,
                    pageNo,
                    pageSize
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.companyList = res.data.page.list
                    console.log(this.companyList);
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 查询对应类型的企业列表
        hanldeItemClick(item,index) {
            this.current = index
            this.getCompanyList(item.id)
        }
    },
}
</script>

<style scoped>
.bloc{
    background: #F2F3F7;
}
.container{
    height: calc(100vh - 1rem);
    overflow: auto;
}
/* 企业风采 */
.public{
    margin-top: .2rem;
    padding: 0 .3rem;
    background: #fff;
}
.public .box{
    position: relative;
    height: .88rem;
    display: flex;
}
.public .box .title{
    font-weight: bold;
    font-size: .28rem;
    color: #D60000;
    margin-top: .3rem;
}
.public .box .line{
    width: 5.6rem;
    height: 0.02rem;
    background: #D60000;
    margin-top: .56rem;
    margin-left: auto;
}
.public .box .more{
    position: absolute;
    right: .14rem;
    color: #666;
    top: 50%;
    transform: translateY(-70%);
    padding: .1rem;
    display: flex;
    align-items: center
}

.public .box .bd{
    position: absolute;
    right: 0;
    top: .44rem;
}
.public .swiper{
    height: 3.3rem;
}
.slideBox{
    width: 100%;
    display: flex;
    align-items: center;
    height: 3.3rem;
}
.public .swiper .swiper-slide img{
    width: 100%;
    max-height: 100%;
}
.public .swiper >>> .my-bullet{
    background: #333;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin: 0 4px;
}
.public .swiper >>> .my-bullet-active{
    width: 20px;
    border-radius: 3px;
    background: #fff;
    opacity: 1;
}
.dis{
    width: 100%;
    height: .5rem;
    line-height: .5rem;
    position: absolute;
    background: rgba(0,0,0,.7);
    color: #fff;
    bottom: 0;
    left: 0;
    padding-left: .16rem;
    box-sizing: border-box;
}
.dis span{
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 4rem;
}
.public .content {
    padding-bottom: .2rem;
}
.public >>> .swiper-pagination{
    height: .5rem;
    text-align: right;
    bottom: 0 !important;
    line-height: .5rem;
}
/* 个人风采 */
.each{
    position: relative;
}
.each .swiperPersonal{
    padding-bottom: .3rem;
}
.each >>> .swiper-wrapper{
    align-items: center;
}
.each .swiper-slide{
    display: flex;
    justify-content: center;
}
.each .swiper-slide .icon{
    width: 1.6rem !important;
    height: 1.6rem;
    border-radius: 50%;
    overflow: hidden;
}
.each .swiper-slide img{
    width: 100%;
    height: 100%;
}
.each .swiper-slide .isShow{
    display: none;
}
.each .swiper-slide-active{
    flex-direction: column;
}
.each .swiper-slide-active .icon{
    width: 2.2rem !important;
    height: 2.2rem;
}
.each .swiper-slide-active .isShow{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: .2rem;
}
.each .swiper-slide-active .isShow p{
    white-space: nowrap;
    margin: .1rem;
}
.swiper-button-prev,.swiper-button-next{
    width: .4rem;
    height: .4rem;
    background-size: 100%; 
    margin-top: 0;
    transform: translateY(50%);
    outline: none;
}
.swiper-button-prev{
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23666666'%2F%3E%3C%2Fsvg%3E");
}
.swiper-button-next{
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23666666'%2F%3E%3C%2Fsvg%3E");
}
/* 协会活动 */
.public .activity{
    display: flex;
    height: 2.8rem;
    padding-bottom: .3rem;
}
.public .activity .pic{
    width: 4.2rem;
    height: 2.8rem;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.public .activity .pic img{
    width: 100%;
    height: 100%;
}
.public .activity .rt{
    width: 2.7rem;
    background: #ECEDF1;
    box-sizing: border-box;
    padding: .2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;
}
.public .activity .rt .text{
    line-height: 1.5;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
}
.public .activity .rt .times{
    color: #999; 
    text-align: right;
}
/* 国内企业 */
.public .firmList{
    display: flex;
    flex-wrap: wrap;
}
.public .firmList .firmLis{
    width: 2.28rem;
    height: .8rem;
    background: #ebecf1;
    margin-top: .02rem;
    margin-right: .02rem;
    text-align: center;
    line-height: .8rem;
    flex-grow: 1;
}
.public .firmList .firmLis:nth-of-type(3n){
    margin-right: 0;
}
.public .firmList .active{
    background: #D60000;
    color: #fff;
}
.videoList{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: .2rem;
}
.videolis{
    width: 3.36rem;
    height: 2.72rem;
    margin-bottom: .2rem;
}
.videoList .videolis .icon{
    width: 3.36rem;
    height: 1.9rem;
    display: flex;
    align-items: center;
    overflow: hidden;
}
.videoList .videolis .icon img{
    width: 100%;
    height: 100%;
}
.videoList .videolis .words{
    line-height: 1.5;
    margin-top: .1rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.videoList .videolis .words:last-child{
    color: #999;
}
</style>